/*
 * SPDX-FileCopyrightText: 2021 Zextras <https://www.zextras.com>
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
export const MAX_SUPPORTED_VERSION = 2; // to keep updated adding new versions
export const IRIS_CHECK_URL = '/static/iris/components.json';
export const ZM_AUTH_TOKEN = 'ZM_AUTH_TOKEN';
export const INVALID_PASSWORD_ERR_CODE = 'account.INVALID_PASSWORD';
export const PASSWORD_RECENTLY_USED_ERR_CODE = 'account.PASSWORD_RECENTLY_USED';
export const PASSWORD_LOCKED = 'account.PASSWORD_LOCKED';

export const ZIMBRA_PASSWORD_MIN_LENGTH_ATTR_NAME = 'zimbraPasswordMinLength';
export const ZIMBRA_PASSWORD_MAX_LENGTH_ATTR_NAME = 'zimbraPasswordMaxLength';
export const ZIMBRA_PASSWORD_MIN_UPPERCASE_CHARS_ATTR_NAME = 'zimbraPasswordMinUpperCaseChars';
export const ZIMBRA_PASSWORD_MIN_LOWERCASE_CHARS_ATTR_NAME = 'zimbraPasswordMinLowerCaseChars';
export const ZIMBRA_PASSWORD_MIN_PUNCTUATION_CHARS_ATTR_NAME = 'zimbraPasswordMinPunctuationChars';
export const ZIMBRA_PASSWORD_MIN_NUMERIC_CHARS_ATTR_NAME = 'zimbraPasswordMinNumericChars';
export const ZIMBRA_PASSWORD_MIN_AGE_ATTR_NAME = 'zimbraPasswordMinAge';
export const ZIMBRA_PASSWORD_PERMITTED = 'Permissions';
export const ZIMBRA_PASSWORD_MAX_AGE_ATTR_NAME = 'zimbraPasswordMaxAge';
export const ZIMBRA_PASSWORD_PERMITTED_ATTR_NAME = 'Login';
export const ZIMBRA_PASSWORD_MIN_DIGITS_OR_PUNCS = 'zimbraPasswordMinDigitsOrPuncs';
export const ZIMBRA_PASSWORD_ENFORCE_HISTORY_ATTR_NAME = 'zimbraPasswordEnforceHistory';
export const BLOCK_PERSONAL_DATA_IN_PASSWORD_POLICY = 'blockPersonalDataInPasswordPolicy';
export const BLOCK_COMMON_WORDS_IN_PASSWORD_POLICY = 'blockCommonWordsInPasswordPolicy';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/developer?id=Zextras';
export const APP_STORE_URL = 'https://apps.apple.com/it/developer/zextras/id1435606921';
export const MOBILE = 'mobile';
export const DESKTOP = 'desktop';
export const TABLET = 'tablet';
export const darkReaderDynamicThemeFixes = {
	ignoreImageAnalysis: ['.no-dr-invert *'],
	invert: [],
	css: `
		.tox, .force-white-bg, .tox-swatches-menu, .tox .tox-edit-area__iframe {
			background-color: #fff !important;
			background: #fff !important;
		}
	`,
	ignoreInlineStyle: ['.tox-menu *'],
	disableStyleSheetsProxy: false
};
export const CARBONIO_LOGO_URL = 'https://www.zextras.com';
export const DARK_READER_VALUES = ['auto', 'enabled', 'disabled'] as const;
export const SCALING_OPTIONS = [
	{ value: 75, label: 'xs' },
	{ value: 87.5, label: 's' },
	{ value: 100, label: 'm' },
	{ value: 112.5, label: 'l' },
	{ value: 125, label: 'xl' }
] as const;
export const BASE_FONT_SIZE = 100;
export const SCALING_LIMIT = {
	WIDTH: 1400,
	HEIGHT: 900,
	DPR: 2 // device pixel ratio
} as const;
export const LOCAL_STORAGE_LAST_PRIMARY_KEY = 'config';
export const CHROME = 'Chrome';
export const FIREFOX = 'Firefox';
export const CARBONIO_CE_SUPPORTED_BROWSER_LINK =
	'https://docs.zextras.com/carbonio-ce/html/basics/general.html#browser-compatibility';
export const CARBONIO_SUPPORTED_BROWSER_LINK =
	'https://docs.zextras.com/carbonio/html/basics/general.html#browser-compatibility';
export const FEATURE_RESET_PASSWORD_DISABLED = 'service.FEATURE_RESET_PASSWORD_DISABLED';
export const CONTACT_ADMIN = 'service.CONTACT_ADMIN';
export const RECOVERY_TOKEN = 'recovery-token';
export const PASSWORD = 'password';
export const CARBONIO = 'carbonio';

/////////Sruvi//////////

export const INDRYVE_LOGO_URL = 'https://www.indryve.com';
export const INDRYVE_SUPPORT_URL = 'https://indryve.com/community';
export const INDRYVE_SUPPORTED_BROWSER_LINK = 'https://indryve.com/indryvemail/browser-support/';

///////////Sruvi//////////
